import { render, staticRenderFns } from "./returned_orders.vue?vue&type=template&id=4894a735&"
import script from "./returned_orders.vue?vue&type=script&lang=js&"
export * from "./returned_orders.vue?vue&type=script&lang=js&"
import style0 from "./returned_orders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports